import { useState, useEffect } from "react";
import { IoAddCircleOutline, IoDocumentOutline } from "react-icons/io5";

const CorTaxTypes = (props) => {
  const { taxTypes, errors, setCorForms, setShowForm } = props;

  const [data, setData] = useState([]);

  useEffect(() => {
    const forms = [];

    for (let i = 0; i < taxTypes.length; i++) {
      for (let j = 0; j < taxTypes[i].forms.length; j++) {
        const form = { ...taxTypes[i].forms[j] };
        const item = { ...taxTypes[i] };
        item["tax_type_form_id"] = form.id;
        item["form"] = form.name;
        item["description"] = form.description;

        forms.push(item);
      }
    }

    setData(forms);
  }, [taxTypes]);

  useEffect(() => {
    setCorForms(data);
  }, [data, setCorForms]);

  return (
    <div className="grid grid-cols-2">
      <div className="col-span-2">
        <div className="flex justify-between items-center">
          <label className="text-sm text-gray-400">Tax Types</label>
          <div
            className="flex items-center cursor-pointer"
            onClick={() => setShowForm(true)}
          >
            <IoAddCircleOutline className="text-blue-500" />
            <span className="ml-3 text-sm text-blue-500">Add Tax Type</span>
          </div>
        </div>
        <div className="mt-5">
          {data.length > 0 && (
            <ul className="border border-gray-200 rounded-md divide-y divide-gray-200">
              {data.map((item, index) => {
                return (
                  <li
                    key={index}
                    className="pl-3 pr-4 py-3 flex justify-between text-gray-400 text-sm"
                  >
                    <div className="flex justify-between">
                      <div>
                        <p>{item.name}</p>
                        <span>{item.form}</span>
                      </div>
                    </div>
                  </li>
                );
              })}
            </ul>
          )}
          {taxTypes.length === 0 && (
            <div className="text-center bg-gray-50 p-4 rounded-xl mb-2 border border-collapse">
              <div className="flex items-center">
                <IoDocumentOutline className="text-lg text-gray-500" />
                <p className="text-gray-500 text-sm ml-2">
                  You have not added any tax types yet
                </p>
              </div>
            </div>
          )}
          {errors && errors["cor_forms"] && (
            <div className="pt-2">
              <span className="text-sm text-red-400">
                {errors["cor_forms"].message}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default CorTaxTypes;
